import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class ControlResumidoService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    // OJO QUE ES USADO DESDE 2 VISTAS DIFERENTES MODAL-CONTROL-EFECTIVO Y LIQUIDACION-CONTROL-EFECTIVO
    validarControlResume(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: declaracionDTOInputType) {
          control_resumido {
            validarControlResume(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                tipo
                texto
              }
              respuesta {
                efectivo_recaudado
                cantidad_transferencias
                monto_deposito
                monto_cheque
                diferencia_monto
                total_pagoacuenta
                total_resumen
                listaDepositos {
                  numero_deposito
                  monto
                  tipo_cuenta_bancaria_codigo
                  banco_codigo
                  banco_nombre
                  numero_cuenta
                  fecha_deposito
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.control_resumido.validarControlResume;
            callback({ mensajes, respuesta });
        });
    }
    obtenerControlResumenSegunFiltro(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: control_resumidoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          control_resumido {
            obtenerControlResumenSegunFiltro(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  codigo
                  empresa_rut
                  sucursal_codigo
                  fecha_registro
                  efectivo_recaudado
                }
              }
            }
          }
        }
        
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.control_resumido.obtenerControlResumenSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
    obtenerControlResumenTotalEfectivo(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: control_resumidoInputType) {
          control_resumido {
            obtenerControlResumenTotalEfectivo(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                empresa_rut
                sucursal_codigo
                total_resumen
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.control_resumido.obtenerControlResumenTotalEfectivo;
            callback({ mensajes, respuesta });
        });
    }
}
ControlResumidoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ControlResumidoService_Factory() { return new ControlResumidoService(i0.ɵɵinject(i1.GraphQLClient)); }, token: ControlResumidoService, providedIn: "root" });
